import { flow } from 'mobx-state-tree';
import { LoadableStatus } from '..';

export const basicLoadableFetch = flow(function* (
  self,
  apiUrl,
  fetchOptions = { credentials: 'include' },
  onSuccess = onSuccessDefault,
  onError = onErrorDefault,
) {
  if (self.status === LoadableStatus.loading) return;

  self.status = LoadableStatus.loading;

  try {
    const response = yield fetch(apiUrl, fetchOptions);

    if (response.status !== 200) throw new Error('Invalid server response.');

    const data = yield response.json();
    onSuccess(self, data);
  } catch (error) {
    onError(self, error, apiUrl);
  }
});

const onErrorDefault = (self, error, apiUrl) => {
  console.error(`Error in basic fetch for '${apiUrl}': `, error);
  self.setStatus(LoadableStatus.error);
};

const onSuccessDefault = (self, data) => {
  self.setData(data);
  self.setStatus(LoadableStatus.done);
};
